export const ReviewIcon: React.FC<{ color: string }> = (props: { color: string }) => {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="review-icon-wrapper">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.875 9.1665C1.875 8.82133 2.15482 8.5415 2.5 8.5415H8.33333C8.67851 8.5415 8.95833 8.82133 8.95833 9.1665C8.95833 9.51168 8.67851 9.7915 8.33333 9.7915H2.5C2.15482 9.7915 1.875 9.51168 1.875 9.1665Z"
                fill={props.color ?? '#4B286D'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.875 13.3335C1.875 12.9883 2.15482 12.7085 2.5 12.7085H8.33333C8.67851 12.7085 8.95833 12.9883 8.95833 13.3335C8.95833 13.6787 8.67851 13.9585 8.33333 13.9585H2.5C2.15482 13.9585 1.875 13.6787 1.875 13.3335Z"
                fill={props.color ?? '#4B286D'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.051 8.67372C17.3232 8.88601 17.3717 9.27875 17.1595 9.55093L13.9095 13.7176C13.7935 13.8663 13.6165 13.9547 13.428 13.9581C13.2394 13.9615 13.0594 13.8796 12.9381 13.7352L11.1881 11.6519C10.9661 11.3876 11.0003 10.9933 11.2646 10.7713C11.5289 10.5493 11.9232 10.5836 12.1452 10.8479L13.3986 12.3401L16.1738 8.78214C16.3861 8.50996 16.7789 8.46142 17.051 8.67372Z"
                fill={props.color ?? '#4B286D'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.875 5C1.875 4.65482 2.15482 4.375 2.5 4.375H11.25C11.5952 4.375 11.875 4.65482 11.875 5C11.875 5.34518 11.5952 5.625 11.25 5.625H2.5C2.15482 5.625 1.875 5.34518 1.875 5ZM14.1667 5C14.1667 4.65482 14.4465 4.375 14.7917 4.375H16.6667C17.0118 4.375 17.2917 4.65482 17.2917 5C17.2917 5.34518 17.0118 5.625 16.6667 5.625H14.7917C14.4465 5.625 14.1667 5.34518 14.1667 5Z"
                fill={props.color ?? '#4B286D'}
            />
        </svg>
    )
}
